import { postRoute } from "../client"
import type { EngagementDto } from "../../shared/engagementTypes"

export const engagementCheckInRoute = postRoute<EngagementDto>("/api/engagement/check-in")
